// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"_2WPqT","avatarInitials":"LT25n","avatarImage":"_3XkQ9"};